module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "top_bar clearfix"
  }, [_c('div', {
    staticClass: "left_social"
  }, [_c('div', {
    staticClass: "social_list"
  }, [(_vm.props.acf.social_list) ? _c('ul', _vm._l((_vm.props.acf.social_list), function(SocialList) {
    return _c('li', [_c('a', {
      attrs: {
        "href": SocialList.url,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": SocialList.img,
        "alt": ""
      }
    })])])
  })) : _vm._e()])]), _c('div', {
    staticClass: "right_contact"
  }, [(_vm.props.acf.phone_icon) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.phone_icon,
      "alt": ""
    }
  }) : _vm._e(), (_vm.props.acf.phone) ? _c('a', {
    attrs: {
      "href": "tel:" + _vm.props.acf.phone,
      "itemprop": "telephone"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.phone)
    }
  }) : _vm._e()])]), _c('div', {
    staticClass: "logo_menu_section clearfix"
  }, [_c('div', {
    staticClass: "logo_header"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [(_vm.props.acf.logo) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.logo,
      "alt": "logo"
    }
  }) : _vm._e()])], 1), _c('nav', {
    staticClass: "navigation navigation_header"
  }, [_vm._m(0), _c('ul', {
    staticClass: "main_menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Welcome")]), _c('ul', {
    staticClass: "sub_menu"
  }, [_c('li', [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.welcome1Click()
      }
    }
  }, [_vm._v("Meet Dr. Wong")])]), _c('li', [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.welcome2Click()
      }
    }
  }, [_vm._v("Meet The Team")])]), _c('li', [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.welcome3Click()
      }
    }
  }, [_vm._v("Testimonials")])])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/new-patients"
    }
  }, [_vm._v("New Patients")]), _c('ul', {
    staticClass: "sub_menu"
  }, [_c('li', [(_vm.props.acf.new_patient) ? _c('a', {
    attrs: {
      "href": _vm.props.acf.new_patient,
      "target": "_blank"
    }
  }, [_vm._v("New Patient Form ")]) : _vm._e()])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/your-perfect-treatment"
    }
  }, [_vm._v("Your Perfect Treatment")]), _c('ul', {
    staticClass: "sub_menu"
  }, [_c('li', [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.treatment1Click()
      }
    }
  }, [_vm._v("Kids")])]), _c('li', [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.treatment2Click()
      }
    }
  }, [_vm._v("Teens")])]), _c('li', [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.treatment3Click()
      }
    }
  }, [_vm._v("Adults  ")])]), _c('li', [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.treatment4Click()
      }
    }
  }, [_vm._v("Surgical ")])])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/creating-your-smile"
    }
  }, [_vm._v("Creating Your Smile")]), _c('ul', {
    staticClass: "sub_menu"
  }, [_c('li', [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.smile1Click()
      }
    }
  }, [_vm._v("Titanium Orthos")])]), _c('li', [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.smile2Click()
      }
    }
  }, [_vm._v("Symetri Clear Braces")])]), _c('li', [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.smile3Click()
      }
    }
  }, [_vm._v("Invisalign  ")])]), _c('li', [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.smile4Click()
      }
    }
  }, [_vm._v("Types of Appliances ")])]), _c('li', [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.smile5Click()
      }
    }
  }, [_vm._v("iTero")])]), _c('li', [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.smile6Click()
      }
    }
  }, [_vm._v("In-House Lab")])])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/life-with-braces"
    }
  }, [_vm._v("Life With Braces ")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/patient-contests"
    }
  }, [_vm._v("Patient Contests ")])], 1), _c('li', [_c('span', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal1",
      modifiers: {
        "modal1": true
      }
    }],
    staticClass: "contactbtn"
  }, [_vm._v("Contact"), _c('b-modal', {
    attrs: {
      "id": "modal1",
      "title": "Contact Us"
    }
  }, [_c('div', {
    staticClass: "modal-content-main"
  }, [_c('div', {
    staticClass: "formcontactt"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 popupabout_info"
  }, [(_vm.propsfoot.acf.address) ? _c('div', {
    staticClass: "addpopup",
    domProps: {
      "innerHTML": _vm._s(_vm.propsfoot.acf.address)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "phonepopup"
  }, [(_vm.props.acf.phone) ? _c('a', {
    attrs: {
      "href": "tel:" + _vm.props.acf.phone,
      "itemprop": "telephone"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.phone)
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "popupemail"
  }, [(_vm.props.acf.email) ? _c('a', {
    attrs: {
      "href": "mailto:" + _vm.props.acf.email,
      "itemprop": "email"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.email)
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "hourspopup"
  }, [(_vm.props.acf.hours) ? _c('a', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.hours)
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "mappopup"
  }, [(_vm.props.acf.map_source) ? _c('iframe', {
    staticClass: "map-iframe",
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": _vm.props.acf.map_source,
      "allowfullscreen": "",
      "width": "100%",
      "height": "250",
      "frameborder": "0"
    }
  }) : _vm._e()])]), _c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('ContactForm')], 1)])])])])], 1)])]), _c('div', {
    staticClass: "mobile-nav-manual"
  }, [_c('div', {
    staticClass: "mobile_menu",
    attrs: {
      "id": "mobileSideNav"
    }
  }, [_vm._m(1), _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('router-link', {
    staticClass: "header-nav-item",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Welcome")]), _vm._m(2), _c('ul', {
    staticClass: "sub_menuu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-1"
    }
  }, [_c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.welcome1Click()
      }
    }
  }, [_vm._v("Meet Dr. Wong")])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.welcome2Click()
      }
    }
  }, [_vm._v("Meet The Team")])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.welcome3Click()
      }
    }
  }, [_vm._v("Testimonials ")])])])], 1), _c('li', [_c('router-link', {
    staticClass: "header-nav-item",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/new-patients"
    }
  }, [_vm._v("New Patients")]), _vm._m(3), _c('ul', {
    staticClass: "sub_menuu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-2"
    }
  }, [_c('li', [(_vm.props.acf.new_patient) ? _c('a', {
    attrs: {
      "href": _vm.props.acf.new_patient,
      "target": "_blank"
    }
  }, [_vm._v("New Patient Form                                                                     ")]) : _vm._e()])])], 1), _c('li', [_c('router-link', {
    staticClass: "header-nav-item",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/your-perfect-treatment"
    }
  }, [_vm._v("Your Perfect Treatment")]), _vm._m(4), _c('ul', {
    staticClass: "sub_menuu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-3"
    }
  }, [_c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.treatment1Click()
      }
    }
  }, [_vm._v("Kids")])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.treatment2Click()
      }
    }
  }, [_vm._v("Teens")])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.treatment3Click()
      }
    }
  }, [_vm._v("Adults")])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.treatment4Click()
      }
    }
  }, [_vm._v("Surgical                    ")])])])], 1), _c('li', [_c('router-link', {
    staticClass: "header-nav-item",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/creating-your-smile"
    }
  }, [_vm._v("Creating Your Smile")]), _vm._m(5), _c('ul', {
    staticClass: "sub_menuu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-4"
    }
  }, [_c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.smile1Click()
      }
    }
  }, [_vm._v("Titanium Orthos")])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.smile2Click()
      }
    }
  }, [_vm._v("Symetri Clear Braces")])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.smile3Click()
      }
    }
  }, [_vm._v("Invisalign  ")])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.smile4Click()
      }
    }
  }, [_vm._v("Types of Appliances ")])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.smile5Click()
      }
    }
  }, [_vm._v("iTero                    ")])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "customclick",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.smile6Click()
      }
    }
  }, [_vm._v("In-House Lab")])])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/life-with-braces"
    }
  }, [_c('span', [_vm._v("Life With Braces ")])])], 1), _c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/patient-contests"
    }
  }, [_c('span', [_vm._v("Patient Contests ")])])], 1), _c('li', [_c('span', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal1",
      modifiers: {
        "modal1": true
      }
    }],
    staticClass: "contactbtn"
  }, [_vm._v("Contact                                                                                                                                                                                          ")])])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hamb_icon",
    attrs: {
      "onclick": "openNav()"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "closebtn idw-icon-close",
    attrs: {
      "href": "javascript:void(0)",
      "onclick": "closeNav()"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "onclick": "subMenu(1)",
      "id": "toggleClass-1"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "onclick": "subMenu(2)",
      "id": "toggleClass-2"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "onclick": "subMenu(3)",
      "id": "toggleClass-3"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "onclick": "subMenu(4)",
      "id": "toggleClass-4"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43a24acc","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/header/header.pug
// module id = 823
// module chunks = 1